import React from 'react'
import { Navigate } from 'react-router-dom'
import {
  rmnPrepPacksEndpoint,
  rmnPrepPackEndpoint,
  rmnPrepPackRegenerateEndpoint,
} from '../../api/endpoints'
import PrepPackList from '../../components/PrepPack/PrepPackList'
import { useNetworkScope } from '../../hooks/useNetworkScope'

// RMN white-label prep packs: the same tool as the internal sales page but
// against the rmnControl-scoped /rmn/prep-packs endpoints. Delete is
// available to every rmn-authorized user (internal with access and brand
// roles alike); the API DELETE is network-scoped. Brand theming arrives via
// the --rmn-* CSS vars set by RmnBrandLayout.
//
// Network plans (Enterprise RMN / Agency) only: the reports are run on the
// other brands in a network's catalog. Single brands have no entry in the
// rail and land on PDP History if they follow an old link.
export default function RmnPrepPackPage() {
  const { isNetwork, basePath } = useNetworkScope()
  if (!isNetwork) return <Navigate to={`${basePath}/intelligence/pdp-history`} replace />
  return (
    <PrepPackList
      endpoints={{
        list: rmnPrepPacksEndpoint,
        item: rmnPrepPackEndpoint,
        regenerate: rmnPrepPackRegenerateEndpoint,
      }}
      allowDelete
      // Ad-hoc reports (any brand + product URLs, catalog or not), exactly
      // like the internal sales page; Catalog > Brands rows keep their
      // one-click run too.
    />
  )
}
